<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('cities.create')
  }),
  computed: {
    ...mapState('cities', ['routeKey', 'routes', 'form', 'item']),
    crumbs: (vm) => [
      { text: vm.$t('cities.title'), to: { name: 'cities.index' } },
      { text: vm.$t('cities.create') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('cities/clearItem')
      await store.dispatch('cities/fetchCountries')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('cities', ['createItem', 'updateItem'])
  }
}
</script>
